import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Icon from "@/components/Icons";
import { pageRect } from "@/lib/density";

/** Meniul „⋮” al unui rând de tabel: butonul rotunjit deschide o listă de acțiuni (fiecare un buton cu contur).
 *  `items`: [{ label, onClick, icon?, disabled?, title?, danger?, testid? }] sau `render` pentru elemente proprii (ex. ștergere definitivă). */
export default function RowMenu({ items = [], children, testid }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const btn = useRef(null);
  const box = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!box.current?.contains(e.target) && !btn.current?.contains(e.target) && !e.target.closest?.(".modal-backdrop")) setOpen(false); };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    const scroll = () => setOpen(false);
    document.addEventListener("mousedown", close); document.addEventListener("keydown", esc); window.addEventListener("scroll", scroll, true);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", esc); window.removeEventListener("scroll", scroll, true); };
  }, [open]);
  const toggle = () => {
    if (!open && btn.current) {
      const r = pageRect(btn.current);
      const width = Math.min(280, r.vw - 16), below = r.vh - r.bottom;
      setPos({ width, left: Math.max(8, Math.min(r.right - width, r.vw - width - 8)), top: below > 280 ? r.bottom + 6 : Math.max(8, r.top - 6), up: below <= 280 });
    }
    setOpen(o => !o);
  };
  return (
    <>
      <button type="button" className="rowmenu-btn" ref={btn} onClick={toggle} aria-haspopup="menu" aria-expanded={open} aria-label="Acțiuni" data-testid={testid || "row-menu"}>
        <Icon name="dots" size={20} />
      </button>
      {open && createPortal(
        <div className="rowmenu-pop" ref={box} role="menu" style={{ left: pos.left, top: pos.top, width: pos.width, transform: pos.up ? "translateY(-100%)" : undefined }}>
          {items.filter(Boolean).map((it, i) => it.href ? (
            <a key={i} role="menuitem" className="rowmenu-item" href={it.href} target={it.target} rel={it.target ? "noreferrer" : undefined} data-testid={it.testid} onClick={() => setOpen(false)}>
              {it.icon && <Icon name={it.icon} size={20} />}<span>{it.label}</span>
            </a>
          ) : (
            <button key={i} type="button" role="menuitem" className={"rowmenu-item" + (it.danger ? " danger" : "")} disabled={it.disabled} title={it.title}
              onClick={() => { setOpen(false); it.onClick && it.onClick(); }} data-testid={it.testid}>
              {it.icon && <Icon name={it.icon} size={20} />}<span>{it.label}</span>
            </button>))}
          {children}
        </div>, document.body)}
    </>
  );
}
